import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleHeading1 } from '@cian/ui-kit';
import { checkFsk } from '../../selectors';
import { About as AboutComponent } from '../../components/About';
import { DeveloperDescription } from '../DeveloperDescription';
import { WorkRegions } from '../WorkRegions';
import { ReliableDeveloper } from '../ReliableDeveloper';

export function About() {
  const isFsk = useSelector(checkFsk);

  return (
    <AboutComponent
      title={<ArticleHeading1>О застройщике</ArticleHeading1>}
      description={<DeveloperDescription />}
      regions={<WorkRegions />}
      reliable={<ReliableDeveloper />}
      hasReliablePadding={isFsk}
    />
  );
}
